import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/TextHFive.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(a, { ref: r, ...t, weights: i }));
o.displayName = "TextHFiveIcon";
const s = o;
export {
  s as TextHFive,
  o as TextHFiveIcon
};
